import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MonetaryValueComponent } from '../../../monetary-value/monetary-value.component';
import { SlipComponentStatusReasonComponent } from '../../slip-component-status-reason/slip-component-status-reason.component';
import { SlipComponentStatusComponent } from '../../slip-component-status/slip-component-status.component';
import { ComponentStatus } from '../../student-slip-modal.store';

export interface StatusReasonModel {
  iconSrc?: string;
  heading: string;
  message?: string;
}
@Component({
  selector: 'app-student-slip-payment-info',
  templateUrl: './student-slip-payment-info.component.html',
  styleUrls: ['./student-slip-payment-info.component.scss'],
  imports: [NgClass, MonetaryValueComponent, SlipComponentStatusComponent, SlipComponentStatusReasonComponent]
})
export class StudentSlipPaymentInfoComponent {
  @Input() balance: number;
  private statusBacking: ComponentStatus;
  @Input() set status(value: ComponentStatus) {
    this.statusBacking = value;
    this.statusReason = this.getStatusReason(value);
  }
  get status(): ComponentStatus {
    return this.statusBacking;
  }
  @Input() amountDue: number;
  @Input() processingPayment: boolean;
  @Input() confirmationPending: boolean;
  statusReason: StatusReasonModel;

  private getStatusReason(status: ComponentStatus): StatusReasonModel {
    if (status === 'done' && !this.balance) {
      return {
        iconSrc: '/assets/icon/tick-icon-green.svg',
        heading: 'PAID IN FULL'
      };
    } else if (status === 'expired') {
      return {
        iconSrc: '/assets/icon/grey-no-entry-outline.svg',
        heading: 'Payment no longer available.',
        message: 'This slip is now closed.'
      };
    } else if (status === 'restricted') {
      return {
        iconSrc: '/assets/icon/grey-no-entry-outline.svg',
        heading: 'Payment is currently restricted.',
        message: 'Please complete the consent response as required before attempting to pay.'
      };
    } else if (status === 'void') {
      return {
        iconSrc: '/assets/icon/grey-no-entry-outline.svg',
        heading: 'Payment no longer available.',
        message: 'Consent needed for this slip has been declined.'
      };
    }
  }
}
